import formBaseMixin from '../../../components/form/form-base-mixin.js'
import {TreeAttributes} from "../../../components/address/address-tree"
import {core, billing} from "../../../api/api-endpoints"

export const billFormMixin = {
  mixins: [formBaseMixin],
  data: () => ({
    fields: {
      account_number: '',
      date_opened: '',
      owner_id: '',
      bankName: '',
      bank_id: '',
      certificate_date: '',
      certificate_number: '',
      account_status: '',
      date_closed: '',
      file_id: '',
      file: {
        /*created_at: null,
        ext: "jpg",
        id: 331,
        name: "girl.jpg",
        size: 68705,
        url: "core/file/331/girl.jpg",
        user_email: "dem0@test.ru",
        user_id: 44*/
      }
    }
  }),
  computed: {
    TREE_ATTRIBUTES () {
      const tree = new TreeAttributes()
      tree.localities.next = null
      delete tree.areas
      delete tree.streets
      delete tree.house
      return tree
    },
    collection () {
      return this.$store.getters.readUrlEndpoint(
        this.getCollectionEndpoint()
      ) || {}
    },
    statuses () {
      return this.collection.billing_account_status || []
    },
    owners () {
      return []
    }
  },
  methods: {
    uploadUrl () {
      return core.file()
    },
    fileUploaded (file) {
      this.fields.file = file
      this.fields.file_id = file.id
    },
    fileRemoved () {
      this.fields.file = {}
      this.fields.file_id = null
    },
    suggestionBankEndpoint (ctx, q) {
      return billing.banks({
        query: {
          q,
          'per-page': 50,
          billOfWasteGenerator: true
        }
      })
    },
    transformBankSuggestions (ctx, data) {
      return data.data.map(item => {
        return {
          id: item.id,
          name: `${item.name}`,
          item
        }
      })
    },
    selectBankItem ($event) {
      if ($event && $event.id) {
        this.fields.bank_id = $event.id
        this.fields.bankName = $event.name
      } else {
        this.fields.bank_id = ''
        this.fields.bankName = ''
      }
    }
  },
  /**
   * @override
   */
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    promises.push(store.dispatch('updateUrlEndpoint', {
      endpoint: methods.getCollectionEndpoint(),
      fromCache: true
    }))

    return Promise.all(promises)
  }
}
